const TRANSPORT_DIRECTION = {
    PICKUP: '1',
    DROPOFF: '2'
}

export { TRANSPORT_DIRECTION }
export default TRANSPORT_DIRECTION



// WEBPACK FOOTER //
// ./src/enums/transportStatus.js